<template>
  <div class="new-vehicles">

    <div class="d-none d-lg-block"><SearchCrumbs></SearchCrumbs></div>

    <SearchSortBy></SearchSortBy>

    <div v-if="totalNumCars > 0">

      <SearchPagination></SearchPagination>

      <SearchResults></SearchResults>

      <SearchPagination></SearchPagination>

    </div>

    <div v-if="totalNumCars === 0">

      <SearchResultsEmpty></SearchResultsEmpty>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

import SearchResults from '@/components/SearchResults.vue'
import SearchPagination from '@/components/SearchPagination.vue'
import SearchSortBy from '@/components/SearchSortBy.vue'
import SearchCrumbs from '@/components/SearchCrumbs.vue'
import SearchResultsEmpty from '@/components/SearchResultsEmpty.vue'

export default {
  name: 'NewVehicles',
  components: {
    SearchResults,
    SearchPagination,
    SearchSortBy,
    SearchCrumbs,
    SearchResultsEmpty
  },
  computed: {
    ...mapState(['totalNumCars'])
  },
  data () {
    return {
    }
  }
}
</script>

<style>

  [v-cloak] {
    display: none;
  }

</style>
